import { render, staticRenderFns } from "./WapIndexLayout.vue?vue&type=template&id=1106c245&scoped=true"
import script from "./WapIndexLayout.vue?vue&type=script&lang=js"
export * from "./WapIndexLayout.vue?vue&type=script&lang=js"
import style0 from "./WapIndexLayout.vue?vue&type=style&index=0&id=1106c245&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1106c245",
  null
  
)

export default component.exports